import React from 'react'

const NiCredit = () => {
    return (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.5816 8.27917C12.737 7.32896 11.2548 7.3213 10.4004 8.26273L9.81906 8.90326C8.62909 10.2144 7.81982 11.8257 7.47859 13.5631V13.5631C7.21596 14.9004 8.10402 16.1922 9.44662 16.4259L9.65937 16.4629C11.2083 16.7325 12.7921 16.7325 14.3409 16.4629L14.5581 16.4251C15.8967 16.1921 16.7804 14.9019 16.514 13.5695V13.5695C16.1775 11.8869 15.3993 10.324 14.2593 9.0415L13.5816 8.27917Z" stroke="currentColor" stroke-width="1.75"></path></svg>
    )
}

export default NiCredit
